/**
 * Which build of the shell this page is running.
 *
 * A stale service-worker shell is invisible: the page looks like the app, it
 * just is not the app that was deployed. Without a release stamped into the
 * bundle at build time there is nothing to compare, and diagnosing a stuck
 * client needs developer tools. The value is a build-time constant rather than
 * a fetch precisely because a stale shell must be able to say what it is while
 * the network is unreachable.
 */

declare const __RECALLVAULT_RELEASE__: string;

const DEVELOPMENT = "dev";

function declaredRelease(): string {
  // `typeof` guards the case where the define never ran, which is any consumer
  // that loads this module outside a Vite build.
  return typeof __RECALLVAULT_RELEASE__ === "string" ? __RECALLVAULT_RELEASE__ : DEVELOPMENT;
}

export const RELEASE: string = declaredRelease();

/** What a person reads in the account area. Never empty, never a bare hash. */
export function releaseLabel(release: string): string {
  const trimmed = release.trim();
  if (trimmed === "" || trimmed === DEVELOPMENT) return "Development build";
  return `Release ${trimmed}`;
}
